// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Recommendation - Personalization */
.RecommendationPersonalizationPresent-Banner-Container {
  position: relative;
  overflow: hidden;
  padding: 0 20px;
  border-radius: 8px;
  background-image: url('https://cdn.boostcommerce.io/assets/recommendation/gradient-horizontal.png');
}

.RecommendationPersonalizationPresent-Banner-Container .banner-dismiss {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 12;
}

.RecommendationPersonalizationPresent-Banner-Container .banner-detail {
  display: flex;
  justify-content: space-around;
  grid-gap: 20px;
  gap: 20px;
  padding-bottom: 1rem;
}

.RecommendationPersonalizationPresent-Banner-Container .banner-detail .banner-content {
  width: 55%;
  text-align: center;
}

.RecommendationPersonalizationPresent-Banner-Container .banner-detail .title {
  margin-top: 2rem;
}

.RecommendationPersonalizationPresent-Banner-Container .banner-detail .title img {
  max-width: 411px;
}

.RecommendationPersonalizationPresent-Banner-Container .banner-detail p {
  font-size: 14px;
  font-weight: 500;
  line-height: 16.8px;
  color: #5b5b5b;
}

.RecommendationPersonalizationPresent-Banner-Container .banner-detail .Polaris-Button--destructive {
  padding: 8px 26px 8px 26px;
  background: linear-gradient(93.3deg, #fb6059 0.83%, #9f53ff 97.3%);
  --pc-button-color: #ff5f6d;
  position: absolute;
  bottom: 1rem;
  right: 22px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 140px;
}

.RecommendationPersonalizationPresent-Banner-Container .banner-detail .Polaris-Button__Text {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.RecommendationPersonalizationPresent-Banner-Container .banner-detail .image {
  width: 40%;
  max-width: 326px;
  z-index: 10;
  position: relative;
}

.RecommendationPersonalizationPresent-Banner-Container .banner-detail img {
  width: 100%;
  height: auto;
}

@media (max-width: 48em) {
  .RecommendationPersonalizationPresent-Banner-Container .banner-detail {
    display: block;
  }

  .RecommendationPersonalizationPresent-Banner-Container .banner-detail .banner-content {
    width: 100%;
  }

  .RecommendationPersonalizationPresent-Banner-Container .banner-detail .image {
    width: 100%;
    max-width: 100%;
  }
}

/* End Present banner */
`, "",{"version":3,"sources":["webpack://./src/styles/recommendation-personalization.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mGAAmG;AACrG;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,kEAAkE;EAClE,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,uBAAuB","sourcesContent":["/* Recommendation - Personalization */\n.RecommendationPersonalizationPresent-Banner-Container {\n  position: relative;\n  overflow: hidden;\n  padding: 0 20px;\n  border-radius: 8px;\n  background-image: url('https://cdn.boostcommerce.io/assets/recommendation/gradient-horizontal.png');\n}\n\n.RecommendationPersonalizationPresent-Banner-Container .banner-dismiss {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 12;\n}\n\n.RecommendationPersonalizationPresent-Banner-Container .banner-detail {\n  display: flex;\n  justify-content: space-around;\n  grid-gap: 20px;\n  gap: 20px;\n  padding-bottom: 1rem;\n}\n\n.RecommendationPersonalizationPresent-Banner-Container .banner-detail .banner-content {\n  width: 55%;\n  text-align: center;\n}\n\n.RecommendationPersonalizationPresent-Banner-Container .banner-detail .title {\n  margin-top: 2rem;\n}\n\n.RecommendationPersonalizationPresent-Banner-Container .banner-detail .title img {\n  max-width: 411px;\n}\n\n.RecommendationPersonalizationPresent-Banner-Container .banner-detail p {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16.8px;\n  color: #5b5b5b;\n}\n\n.RecommendationPersonalizationPresent-Banner-Container .banner-detail .Polaris-Button--destructive {\n  padding: 8px 26px 8px 26px;\n  background: linear-gradient(93.3deg, #fb6059 0.83%, #9f53ff 97.3%);\n  --pc-button-color: #ff5f6d;\n  position: absolute;\n  bottom: 1rem;\n  right: 22px;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  width: 140px;\n}\n\n.RecommendationPersonalizationPresent-Banner-Container .banner-detail .Polaris-Button__Text {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n}\n\n.RecommendationPersonalizationPresent-Banner-Container .banner-detail .image {\n  width: 40%;\n  max-width: 326px;\n  z-index: 10;\n  position: relative;\n}\n\n.RecommendationPersonalizationPresent-Banner-Container .banner-detail img {\n  width: 100%;\n  height: auto;\n}\n\n@media (max-width: 48em) {\n  .RecommendationPersonalizationPresent-Banner-Container .banner-detail {\n    display: block;\n  }\n\n  .RecommendationPersonalizationPresent-Banner-Container .banner-detail .banner-content {\n    width: 100%;\n  }\n\n  .RecommendationPersonalizationPresent-Banner-Container .banner-detail .image {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n/* End Present banner */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
